<div class="invoice">
    <div class="invoice-userData">
        <div class="invoice-userData-name">
            <a href="#" class="arrowIcon">
                <i class="fas fa-chevron-right"></i>
            </a>
            <h2 class="userName">عزام العيسى</h2>
        </div>
        <div class="invoice-userData-action">
            <button class="btn btn-light">
                <i class="fas fa-print text-primary mr-3"></i>
                <span class="font-weight-bold">طباعة الفاتورة</span>
            </button>
        </div>

    </div>
    <div class="letter">
        <div class="letter-header">
            <img src="../../../assets/images/dummy/letter-header.PNG" alt="" class="image roundTop">
        </div>
        <div class="letter-body">
            <div class="row">
                <div class="col-12 col-md-6">
                    <p class="standard">شركة مناص لتقنية المعلومات</p>
                </div>
                <div class="col-12 col-md-6">
                    <p>
                        <span class="props">اسم العميل:</span>
                        <span class="propsInfo">سند لمساحة العمل المشتركة</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props"> رقم السجل التجارى:</span>
                        <span class="propsInfo">1010474549</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props"> رقم التسجيل الضريبى:</span>
                        <span class="propsInfo">310253351200003</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props">تاريخ التقرير:</span>
                        <span class="propsInfo">15-07-2021</span>
                    </p>
                </div>
                <div class="col-12 text-center">
                    <p class="standard">
                        تقرير مبيعات التذاكر
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props"> رقم التقرير:</span>
                        <span class="propsInfo">TS-346</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props">اسم الفعالية:</span>
                        <span class="propsInfo">ماذا بعد التخرج للمتخصين بقطاع التغذية</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props">تاريخ انتهاء الفعالية:</span>
                        <span class="propsInfo">28-07-2021</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props"> رقم الفعالية:</span>
                        <span class="propsInfo">224851546</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        نشكر لكم اختياركم ايفينتو.
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        نود افادتكم انه تم اصدار التقرير المالى النهائى لفعاليتكم وعليه سيتم تحويل المبلغ المستحق لكم حسب التقرير أدناه الى حسابكم البنكى المسجل لدينا:
                    </p>
                </div>
                <div class="col-12">
                    <table class="table table-bordered text-center">
                        <thead>
                            <tr class="bg-gray-table">
                                <td>البيان</td>
                                <td>{{ 'Number of tickets' | translate }}</td>
                                <td>الاجمالى قبل الخصم</td>
                                <td>خصم الكوبونات</td>
                                <td>الاجمالى بعد الخصم</td>
                                <td>ضريبة القيمة المضافة</td>
                                <td>المبلغ بعد الضريبة</td>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>التذاكر المباعة</td>
                                <td>27</td>
                                <td>1350.00</td>
                                <td>0.00</td>
                                <td>1350.00</td>
                                <td>202.50</td>
                                <td>1552.50</td>
                            </tr>
                            <tr class="bg-gray-table">
                                <td>الاجمالى</td>
                                <td>27</td>
                                <td>1350.00</td>
                                <td>0.00</td>
                                <td>1350.00</td>
                                <td>202.50</td>
                                <td>1552.50</td>
                            </tr>
                            <tr class="emptyRow">
                                <td colspan="8"></td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    رسوم خدمة البيع 4% +1.5ريال
                                </td>
                                <td>-94.5</td>
                                <td>-14.18</td>
                                <td>-108.68</td>
                            </tr>
                            <tr class="bg-gray-table">
                                <td colspan="4">
                                    اجمالى الرسوم
                                </td>
                                <td>-94.5</td>
                                <td>-14.18</td>
                                <td>-108.68</td>
                            </tr>
                            <tr class="emptyRow">
                                <td colspan="8"></td>
                            </tr>
                            <tr class="bg-gray-table">
                                <td colspan="4">
                                    الصافى
                                </td>
                                <td>1255.5</td>
                                <td>188.33</td>
                                <td>1443.82</td>
                            </tr>
                            <tr class="emptyRow">
                                <td colspan="8"></td>
                            </tr>
                            <tr class="bg-gray-table">
                                <td colspan="4">
                                    المستحق للعميل
                                </td>
                                <td colspan="4">
                                    -1255.5
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <p>* لم يتم تضمين القيمة المضافة نظرا لعدم تسجيلكم فى ضريبة القيمة المضافة و وسيتم توريد قيمة الضريبة المحصلة الى هيئة الزكاة والضريبة والجمارك وسيتم تحويل المبلغ لكم غير شامل الضريبة</p>
                </div>
                <div class="col-12">
                    <p class="standard">
                        بيانات الحساب البنكى للعميل:
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props">اسم البنك:</span>
                        <span class="propsInfo">مصرف الانماء</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props">اسم الحساب:</span>
                        <span class="propsInfo">شركة سند لحاضنات ومسرعات الأعمال</span>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        <span class="props">رقم الآيبان:</span>
                        <span class="propsInfo">SA95050000068202528550100</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="letter-footer">
            <img src="../../../assets/images/dummy/letter-footer.PNG" alt="" class="image roundBtm">
        </div>
    </div>
</div>
